import React, { useEffect, useState } from "react";
import Content from "../../../Components/Dashboard/Content/Content";
import Table from "../../../Components/ExtraComponents/Tables/FullDataTable";
import Loader from "../../../Utils/Loader";
import { fDateTimeSuffix } from "../../../Utils/Date_formet";
import { Get_All_Signals } from "../../../ReduxStore/Slice/Admin/SignalsSlice";
import { useDispatch } from "react-redux";

const Signals = () => {
  const dispatch = useDispatch();

  // 🔹 Detect if this is an "admin go-to-dashboard" context
  const isGoToDashboard = localStorage.getItem("gotodashboard") === "true";
  const userDetails = JSON.parse(
    localStorage.getItem(isGoToDashboard ? "user_details_goTo" : "user_details")
  );

  const token = userDetails?.token;

  const [DateFilter, setDateFilter] = useState();
  const [SignalsData, getSignalsData] = useState({ loading: true, data: [] });

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: false,
      width: "80px",
    },
    {
      name: "Signals Time",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <div>{row.createdAt ? fDateTimeSuffix(row.createdAt) : "-"}</div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Type",
      selector: (row) => row.type,
      sortable: true,
      width: "120px",
    },
    {
      name: "Symbol",
      selector: (row) => row.trade_symbol,
      sortable: true,
      width: "120px",
    },
    {
      name: "Price",
      selector: (row) => row.price,
      sortable: true,
      width: "120px",
    },
    {
      name: "Strategy",
      selector: (row) => row.strategy,
      sortable: true,
      width: "150px",
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (!token) return;
      try {
        const response = await dispatch(
          Get_All_Signals({ startDate: DateFilter, token })
        ).unwrap();

        getSignalsData({
          loading: false,
          data: response.data || [],
        });
      } catch (error) {
        console.error("Error fetching signals:", error);
        getSignalsData({ loading: false, data: [] });
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [DateFilter, token]);

  useEffect(() => {
    const dateArray = [];
    for (let i = 0; i < 3; i++) {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - i);
      const formattedDate = `${currentDate.getFullYear()}/${
        currentDate.getMonth() + 1
      }/${currentDate.getDate()}`;
      dateArray.push(formattedDate);
    }
    setDateFilter(dateArray[0]);
  }, []);

  return (
    <Content Page_title="All Services" button_status={false}>
      {SignalsData.loading ? (
        <Loader />
      ) : (
        <Table columns={columns} data={SignalsData.data} />
      )}
    </Content>
  );
};

export default Signals;
